export const browserNames = {
  googleChrome: "Google Chrome",
  mozillaFirefox: "Mozilla Firefox",
  safari: "Safari",
  microsoftEdge: "Microsoft Edge",
  internetExplorer: "Internet Explorer",
  opera: "Opera",
  braveBrowser: "Brave Browser",
  unknown: "Unknown",
};

const getBrowserName = async () => {
  const userAgent = navigator.userAgent;

  // Brave Browser detection
  if ((navigator as any).brave?.isBrave) {
    const isBrave = await (navigator as any).brave.isBrave();
    if (isBrave) return browserNames.braveBrowser;
  }

  let currentBrowserName = "Unknown";

  if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
    currentBrowserName = browserNames.googleChrome;
  } else if (userAgent.includes('Firefox')) {
    currentBrowserName = browserNames.mozillaFirefox;
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    currentBrowserName = browserNames.safari;
  } else if (userAgent.includes('Edg')) {
    currentBrowserName = browserNames.microsoftEdge;
  } else if (userAgent.includes('MSIE') || userAgent.includes('Trident')) {
    currentBrowserName = browserNames.internetExplorer;
  } else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
    currentBrowserName =  browserNames.opera;
  }

  return currentBrowserName;
}

export default getBrowserName;